import { LiveHubService } from './../../services/livehub.service';
import { AdminHubRegistryRequest } from './../../models/ss-api/requests/admin.hub.registry.request';
import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

export interface IAddRegistryValueDialogModel {
    title: string;
    LicenseKey: string;
    SubKey: string;
}

@Component({
    selector: 'add-registry-value-dialog',
    styleUrls: ['./add.registry.value.dialog.scss'],
    templateUrl: './add.registry.value.dialog.html'
})

export class AddRegistryValueDialog extends DialogComponent<IAddRegistryValueDialogModel, boolean> implements IAddRegistryValueDialogModel, OnInit {
    IsBusy: boolean;
    title: string;

    LicenseKey: string;
    ValueKind: string;
    RegistryForm: FormGroup;
    SubKey: string;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router, private liveHub: LiveHubService) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;
        this.RegistryForm = new FormGroup({
            'Key': new FormControl('', [Validators.required]),
            'Value': new FormControl('', [Validators.required])
        });

        let registrySubscription = this.liveHub.RegistryResponse.subscribe(response => {
            this.IsBusy = false;
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Success!',
                    text: 'Registry value has been added successfully',
                    timer: 1500
                }).then( () => {}, () => {} );

                this.result = true;
                this.close();
            }
        });

    }

    ValueKindChanged(event) {
        this.ValueKind = event.target.value;
    }

    async confirm() {
        if (!this.RegistryForm.valid)
            return false

        this.IsBusy = true;
        let controls = this.RegistryForm.controls;
        let request: AdminHubRegistryRequest = new AdminHubRegistryRequest();

        request.Key = controls['Key'].value;
        request.LicenseKey = this.LicenseKey;
        request.RootString = 'currentuser';
        request.SubKey = this.SubKey;
        request.Value = controls['Value'].value;
        request.ValueKind = this.ValueKind ? this.ValueKind : 'string';

        this.liveHub.InvokeConnection('AddLicenseRegistryValue', request);
    }

}
